import { createSelector } from 'reselect';

export const getLocationStation = (state) => state.locationStation;

export const getLocationStationDate = createSelector(
  getLocationStation,
  ({ date }) => date
);

export const getLocation = createSelector(
  getLocationStation,
  ({ location }) => location
);

export const isLocationStationLoading = createSelector(
  getLocationStation,
  ({ loading }) => loading
);

export const getExerciseTime = createSelector(
  getLocationStation,
  ({ exerciseTime }) => exerciseTime
);
export const getRestTime = createSelector(
  getLocationStation,
  ({ restTime }) => restTime
);

export const getLocationStationId = createSelector(
  getLocationStation,
  ({ id }) => id
);

export const getLocationStationError = createSelector(
  getLocationStation,
  ({ error }) => error
);
